import { ApiError, UnauthenticatedError } from '../api/client'

/**
 * One line per failure class for the step-up modal. Until 2026-09-13 every failure read "That code
 * did not work", which hid a 500 on the API for two days (QA-1/QA-8). Only an actual `invalid_code`
 * answer blames the code; `clearCode` says whether the typed digits should be dropped.
 */
export function stepUpErrorMessage(e: unknown): { message: string, clearCode: boolean } {
  if (e instanceof UnauthenticatedError)
    return { message: 'Your session needs a fresh sign-in before this action.', clearCode: false }
  if (e instanceof ApiError) {
    if (e.status === 401 && e.body.error === 'invalid_code')
      return { message: 'That code did not work. Codes change every 30 seconds.', clearCode: true }
    if (e.status === 403)
      return { message: `This session can't confirm that action${typeof e.body.rule === 'string' ? ` (${e.body.rule})` : ''}. Sign out and back in, then try again.`, clearCode: false }
    if (e.status === 400)
      return { message: 'Enter the six digits from your authenticator.', clearCode: true }
    if (e.status === 429)
      return { message: 'Too many attempts. Wait a few minutes and try again.', clearCode: true }
    return { message: 'Something failed on our side. Your code was not the problem; try again in a moment.', clearCode: false }
  }
  return { message: 'Could not reach Gallop. Check your connection and try again.', clearCode: false }
}
